import { isPushPlatformName } from './getIntegrationStatus'

/**
 * Selects the primary integration to drive sync UI when multiple integrations
 * are active.
 *
 * Preference order:
 *   1. The first push-capable integration (Merge, Codat, legacy NetSuite).
 *   2. The first integration in the list.
 *
 * Why: a tenant can have a native push-capable integration *and* a
 * read-only custom integration (e.g. Workato) active at the same time. The
 * API list ordering is not stable — if the read-only integration lands at
 * index 0, sync UI must still target the push-capable integration. See
 * PLAT-4887.
 *
 * Duck-typed on `{ name: string }` so it works for both the raw
 * `Components.Schemas.IntegrationResponse` and the modern `Integration`
 * entity class — both expose the same URN string under `name`.
 */
export const selectPrimaryIntegration = <T extends { name: string }>(
  integrations: readonly T[]
): T | undefined =>
  integrations.find((integration) => isPushPlatformName(integration.name)) ??
  integrations[0]
